<div
  [class]="[
    'form-check',
    'eod-checkbox',
    'eod-checkbox--' + checkboxInput?.size]">
  <input
    [attr.type]="checkboxInput?.type"
    [class]="['form-check-input',
     'is-'+checkboxInput?.color,
      checkboxInput?.selectAll ? '--select-all' : '']"
      [checked]="checkboxInput?.isSelected"
      (input)="onClick($event)"
      [disabled]="checkboxInput?.isDisabled"
  >
  <label
    [class]="['form-check-label']"
    >
    @if (checkboxInput?.isHtmlLabel) {
      <p [innerHTML]="checkboxInput?.label"></p>
    } @else {
      {{ checkboxInput?.label }}
    }
  </label>
</div>

